import styled from "@emotion/styled";
import type { FunctionComponent } from "react";

import type {
  ContentSchemaRenderProps,
  RenderComponent,
} from "scmp-app/components/schema-render/content";

import { Container, StyledIconShieldAlert, Text } from "./styles";

export type Props = ContentSchemaRenderProps & {
  className?: string;
};

export const Component: FunctionComponent<Props> = ({ className }) => (
  <Container className={className}>
    <StyledIconShieldAlert />
    <Text>Item not supported in this print-friendly version</Text>
  </Container>
);

export const PrintArticleUnsupportedElement: RenderComponent<Props> = styled(Component)``;

PrintArticleUnsupportedElement.isHandlingOwnChildren = true;
PrintArticleUnsupportedElement.displayName = "PrintArticleUnsupportedElement";
